import React from "react";
import { ESize, EColor, EInputStyle } from "./EnumOpt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IControl {
	name: string;
	placeholder: string;
	value: string;
	size: ESize;
	inputStyle: EInputStyle;
	color: EColor;
	type: string;
	leftIcon?: any;
	rightIcon?: any;
	disabled: boolean;
	accept: string;

	onChange(): void;
	onKeyUp(): void;
	onKeyDown(): void;
	onKeyPress(): void;
	onFocus(): void;
	onBlur(): void;
}

export default function index(props: IControl) {
	return (
		<div
			className={`ut-input ${props.size ? `ut-input-${props.size}` : "ut-input-md"} ${props.color ? `ut-input-${props.color}` : "ut-input-primary"} ${
				props.inputStyle ? `ut-input-${props.inputStyle}` : "ut-input-rounded"
			} ${props.disabled ? `ut-input-disabled` : ""}`}
		>
			{props.leftIcon ? <FontAwesomeIcon className="ut-input-left-icon" size="lg" icon={props.leftIcon} /> : null}
			<input
				autoComplete="off"
				onChange={props.onChange}
				onKeyUp={props.onKeyUp}
				onKeyDown={props.onKeyDown}
				onKeyPress={props.onKeyPress}
				onFocus={props.onFocus}
				onBlur={props.onBlur}
				name={props.name}
				type={props.type}
				value={props.value}
				accept={props.accept}
				placeholder={props.placeholder}
			/>
			{props.rightIcon ? <FontAwesomeIcon className="ut-input-right-icon" size="lg" icon={props.rightIcon} /> : null}
		</div>
	);
}
